/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CopyCommentEmbedCodeContainer_story = {
    readonly url: string;
    readonly " $refType": "CopyCommentEmbedCodeContainer_story";
};
export type CopyCommentEmbedCodeContainer_story$data = CopyCommentEmbedCodeContainer_story;
export type CopyCommentEmbedCodeContainer_story$key = {
    readonly " $data"?: CopyCommentEmbedCodeContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"CopyCommentEmbedCodeContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyCommentEmbedCodeContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '16bdba7a405c601e1472f6685282db9a';
export default node;
